import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { SweepstakesMarkdown } from '../../../utils/SweepstakesMarkdown';
import { SWEEPSTAKES_CONSTANTS } from '../../../../../core/Constants';
import { windowExists } from '../../../../../common/utils/AccountUtils';
import { useResponsive } from '../../../../../hooks/use-responsive';

const RenderDescription = ({ description }) => {
  if (!description) return null;

  return (
    <div className="sui-mb-4">
      <SweepstakesMarkdown markdownText={description} variant="stepContent" />
    </div>
  );
};

const RenderFooter = ({ ctaTitle, onClick }) => {
  if (!ctaTitle) return null;

  return (
    <Button
      variant="primary"
      fullWidth
      onClick={onClick}
      data-testid="sweepstakes-step-cta-button"
    >
      {ctaTitle}
    </Button>
  );
};

export const StepContent = ({ step }) => {
  const { isNativeApp, isMobile } = useResponsive();

  if (!step) return { content: null, footer: null };

  const handleCtaClick = () => {
    if (!windowExists()) return;

    const { ctaHref, ctaTitle, eventBusTrigger } = step;
    const hasTriggerAndTitle = Boolean(eventBusTrigger && ctaTitle);

    if (isNativeApp && hasTriggerAndTitle) {
      const payload = SWEEPSTAKES_CONSTANTS.EVENT_BUS.TRIGGER_PAYLOAD?.[eventBusTrigger] || {};
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger(eventBusTrigger, { ...payload });
      return;
    }

    if (ctaHref) {
      window.open(ctaHref, '_blank');
    }
  };

  const content = (
    <div className="sui-space-y-4" data-testid="sweepstakes-step-content">
      <RenderDescription description={step.description} />
    </div>
  );

  const hasFooterCta = Boolean(step?.ctaTitle && (step?.eventBusTrigger || step?.ctaHref));
  const footer = isMobile && hasFooterCta
    ? <RenderFooter ctaTitle={step.ctaTitle} onClick={handleCtaClick} />
    : null;

  return { content, footer };
};

StepContent.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    ctaTitle: PropTypes.string,
    ctaHref: PropTypes.string,
    iconUrl: PropTypes.string,
    eventBusTrigger: PropTypes.string,
    stepMetaData: PropTypes.shape({}),
  }),
};

StepContent.defaultProps = {
  step: null,
};